import { render, staticRenderFns } from "./ImageSelect.vue?vue&type=template&id=0f6060b4&scoped=true&"
import script from "./ImageSelect.vue?vue&type=script&lang=js&"
export * from "./ImageSelect.vue?vue&type=script&lang=js&"
import style0 from "./ImageSelect.vue?vue&type=style&index=0&id=0f6060b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f6060b4",
  null
  
)

export default component.exports